import { constants } from ".";
//
const baseUrl = constants.baseUrl;
export const Urls = {
  pages: `${baseUrl}/pages/home`,
  dealerPage: `${baseUrl}/pages/dealer`,
  painterPage: `${baseUrl}/pages/painter`,
};
